export default __webpack_public_path__ + "static/media/tv-2020-65hz1000-galleryimages-6-200730.d499354b.jpg";